import { Button } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  deleteGalleryImageByIdFn,
  getGalleryImageFn,
} from "../../Services/GalleryImage";

const GalleryImage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const galleryId = state?.gallery_id;

  const { data: getGalleryImage, refetch } = useQuery({
    queryKey: ["get-gallery-image", galleryId],
    queryFn: () => getGalleryImageFn({ gallery_id: galleryId }),
    // 🛑 don’t run without id
  });

  const { mutate: deleteGalleryImage } = useMutation(deleteGalleryImageByIdFn, {
    onSuccess: () => {
      refetch();
      toast.success("Gallery image deleted successfully.");
    },
  });

  const handleDelete = (id) => {
    const formData = new FormData();
    formData.append("gallery_image_id", id);
    deleteGalleryImage(formData);
  };

  return (
    <>
      {/* Heading */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Gallery Image
      </p>

      {/* Add Button */}
      <div className="flex justify-end w-full px-">
        <NavLink to="/gallery-image/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-1">
        {getGalleryImage?.data?.data?.map((item) => (
          <div
            key={item.id}
            className="flex flex-col justify-between p-3 border border-gray-300 rounded shadow hover:shadow-lg transition bg-white"
          >
            {/* Content */}
            <div className="flex flex-col gap-3">
              <p className="text-lg font-semibold text-black">{item.title}</p>

              {item?.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-32 object-cover rounded"
                />
              )}
            </div>

            {/* Actions */}
            <div className="flex justify-center gap-3 pt-4">
              <Button
                variant="outlined"
                onClick={() =>
                  navigate("/gallery-image/update", {
                    state: item.id,
                  })
                }
              >
                Update
              </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={() => handleDelete(item.id)}
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GalleryImage;
